// extracted by mini-css-extract-plugin
export default {"description":"VerifyEmail_description__Ujp+v","first_txt":"VerifyEmail_first_txt__Mek35","lst_txt":"VerifyEmail_lst_txt__U6F8D"};